<dx-popup title="Expanded message info" [shading]="false" [dragEnabled]="false" [(visible)]="isExpandedMessageVisible" (onHiding)="hideExpandedMessageVisible" [height]="'auto'" [hideOnOutsideClick]="true">
	<ng-container *ngIf="isExpandedMessageSubject | async as lines">
		<div class="expanded-message-line" *ngFor="let line of lines">{{line}}</div>
	</ng-container>
</dx-popup>

<div class="container-scheduler">
	<div class="left-div">
		<fieldset style="background-color: white">
			<legend>Link log history</legend>

			<div *ngIf="companyInfo$ | async as companyInfo">
				<div *ngIf="jobDataSourceOData; else noDataTemplate">
					<dx-data-grid [dataSource]="jobDataSourceOData" [showBorders]="true" (onCellClick)="cellClicked($event)" [height]="630" [showColumnHeaders]="false" [remoteOperations]="true">
						<dxo-load-panel [enabled]="true"></dxo-load-panel>
						<dxo-pager [visible]="true" [showPageSizeSelector]="false" [showInfo]="false" [showNavigationButtons]="false"></dxo-pager>
						<dxo-scrolling mode="virtual"></dxo-scrolling>

						<dxi-column caption="Link logs" [width]="200" [allowFiltering]="false" [allowSorting]="false" cellTemplate="cellTemplate"></dxi-column>

						<dxi-column sortOrder="desc" dataField="creationDate" [width]="150" [visible]="false"></dxi-column>

						<dxo-filter-row [visible]="true"></dxo-filter-row>
						<dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

						<div *dxTemplate="let data of 'cellTemplate'">
							<table class="cell-template-table" (contextmenu)="openLogContextMenu($event, data.data)">
								<tr *ngIf="cspMode">
									<th *ngIf="cspMode">Date</th>
									<td>{{ data.data.creationDate | timezoneDate : companyInfo.timezone : companyInfo.dateformat }}</td>
								</tr>
								<tr *ngIf="!cspMode">
									<th>Start Date</th>
									<td>{{ data.data.creationDate | timezoneDate : companyInfo.timezone : companyInfo.dateformat + ' HH:mm' }}</td>
								</tr>
								<tr *ngIf="!cspMode">
									<th>Succeeded</th>
									<td style="color: green">{{ data.data.totalSucceeded }}</td>
								</tr>
								<tr>
									<th *ngIf="cspMode">Exceptions</th>
									<th *ngIf="!cspMode">Failed</th>
									<td style="color: red">{{ data.data.totalFailed }}</td>
								</tr>
								<tr *ngIf="!cspMode">
									<th style="border-bottom: 1px solid #ddd;">Duration</th>
									<td style="border-bottom: 1px solid #ddd;">
										{{ data.data.creationDate | timeDifference: data.data.completionDate }}
									</td>
								</tr>
							</table>
						</div>
					</dx-data-grid>
				</div>
			</div>

			<ng-template #noDataTemplate>
				<div style="text-align: center; padding: 20px;">
					<p>No data available</p>
				</div>
			</ng-template>
		</fieldset>
	</div>

	<div class="right-div">
		<div *ngIf="SelectedDataSource && entriesAvailable">
			<fieldset>
				<legend>Link logs</legend>

				<div *ngIf="tabsSubject | async as tabs">
					<al-tabs [tabInfo]="tabs" [selectedTab$]="selectedTab$"></al-tabs>
				</div>

				<dx-scroll-view [height]="600">
					<div style="padding-top: 15px;">

						<!-- ===================== -->
						<!-- ALL MODE               -->
						<!-- ===================== -->
						<ng-container *ngIf="!(singleModeSelectionSubject | async)">
							<ng-container *ngIf="LogTypPropertiesMapping | async as LogTypPropertiesMappings">
								<ng-container *ngFor="let propertyMapping of LogTypPropertiesMappings">

									<fieldset style="background-color: white">
										<ng-container [ngSwitch]="propertyMapping.LogType">
											<ng-container *ngSwitchCase="'1'">
												<legend>Success</legend>
											</ng-container>
											<ng-container *ngSwitchCase="'2'">
												<legend>Fail</legend>
											</ng-container>
											<ng-container *ngSwitchCase="'3'">
												<legend>Mismatch</legend>
											</ng-container>
											<ng-container *ngSwitchCase="'4'">
												<legend>Error</legend>
											</ng-container>
										</ng-container>

										<dx-data-grid id="gridContainer" [dataSource]="propertyMapping.dataSource" [showBorders]="true" (onRowPrepared)="onRowPrepared($event)" width="100%">

											<dxo-filter-row [visible]="true"></dxo-filter-row>
											<dxo-selection mode="none"></dxo-selection>

											<dxi-column dataField="jobLogType" cellTemplate="iconCellTemplate" [width]="25" caption="" alignment="center" allowFiltering="false">
											</dxi-column>

											<div *dxTemplate="let cell of 'iconCellTemplate'">
												<div [ngSwitch]="cell.text">
													<i *ngSwitchCase="'1'" class="far fa-check success-color"></i>
													<i *ngSwitchCase="'2'" class="far fa-times failure-color"></i>
													<i *ngSwitchCase="'3'" class="far fa-exclamation warning-color"></i>
													<i *ngSwitchCase="'4'" class="far fa-times failure-color"></i>
													<i *ngSwitchDefault class="far fa-eye"></i>
												</div>
											</div>

											<dxi-column sortOrder="desc" width="130px" format="dd-MM-yyyy HH:mm:ss" dataType="date" dataField="creationDate">
											</dxi-column>

											<!-- Dynamic columns (render helpArticles specially) -->
											<ng-container *ngFor="let columnName of propertyMapping.properties">
												<ng-container *ngIf="columnName === 'helpArticles'; else normalColumnAll">
													<dxi-column [dataField]="columnName" caption="Help articles" cellTemplate="helpArticlesTemplate" [width]="'auto'" [minWidth]="160" [allowResizing]="false">
													</dxi-column>
												</ng-container>

												<ng-template #normalColumnAll>
													<ng-container *ngIf="isWideColumn(columnName); else normalNarrowAll">
														<dxi-column [dataField]="columnName"></dxi-column>
													</ng-container>
													<ng-template #normalNarrowAll>
														<dxi-column [dataField]="columnName" width="auto" [caption]="columnName"></dxi-column>
													</ng-template>
												</ng-template>
											</ng-container>

											<!-- Action buttons -->
											<dxi-column type="buttons" width="40px">
												<dxi-button hint="Expand message" icon="search" [onClick]="expandMessageButton"></dxi-button>
											</dxi-column>

											<!-- ✅ helpArticlesTemplate MUST be inside the grid -->
											<div *dxTemplate="let cell of 'helpArticlesTemplate'">
												<!-- Only show anything for Error rows -->
												<ng-container *ngIf="cell.data?.jobLogType == '4'; else empty">
													<ng-container *ngIf="hasAnyArticleIds(cell.value); else requestHelp">
														<div class="mp-cell">
															<div *ngFor="let ha of cell.value" class="mp-row">
																<button *ngIf="ha.articleIds?.length" type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="openIssueHelp(ha, cell.data?.message ?? cell.data?.description ?? null)">
																	View help articles
																</button>
															</div>
														</div>
													</ng-container>

													<ng-template #requestHelp>
														<button type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="requestHelpForRow(cell.data)">
															Request help for this error
														</button>
													</ng-template>
												</ng-container>

												<ng-template #empty>
													<!-- render nothing for non-errors -->
													<span style="display:none;"></span>
												</ng-template>
											</div>




										</dx-data-grid>

										<ng-container *ngIf="propertyMapping.LogType == '3'">
											<div style="font-size:12px">*: This difference is more than just a VAT difference, please check the invoice.
											</div>
											<div style="font-size:12px">**: The difference here is a VAT difference.
											</div>
										</ng-container>
									</fieldset>

								</ng-container>
							</ng-container>
						</ng-container>

						<!-- ===================== -->
						<!-- SINGLE MODE            -->
						<!-- ===================== -->
						<ng-container *ngIf="(singleModeSelectionSubject | async)">
							<fieldset style="background-color: white">
								<ng-container [ngSwitch]="SelectedLogType">
									<ng-container *ngSwitchCase="'1'">
										<legend>Success</legend>
									</ng-container>
									<ng-container *ngSwitchCase="'2'">
										<legend>Fail</legend>
									</ng-container>
									<ng-container *ngSwitchCase="'3'">
										<legend>Mismatch</legend>
									</ng-container>
									<ng-container *ngSwitchCase="'4'">
										<legend>Error</legend>
									</ng-container>
								</ng-container>

								<dx-data-grid id="gridContainer" [dataSource]="SelectedDataSource" [showBorders]="true" (onRowPrepared)="onRowPrepared($event)" width="100%">

									<dxo-filter-row [visible]="true"></dxo-filter-row>
									<dxo-selection mode="none"></dxo-selection>

									<dxi-column dataField="jobLogType" cellTemplate="iconCellTemplate2" [width]="25" caption="" alignment="center" allowFiltering="false">
									</dxi-column>

									<div *dxTemplate="let cell of 'iconCellTemplate2'">
										<div [ngSwitch]="cell.text">
											<i *ngSwitchCase="'1'" class="far fa-check success-color"></i>
											<i *ngSwitchCase="'2'" class="far fa-times failure-color"></i>
											<i *ngSwitchCase="'3'" class="far fa-exclamation warning-color"></i>
											<i *ngSwitchCase="'4'" class="far fa-times failure-color"></i>
											<i *ngSwitchDefault class="far fa-eye"></i>
										</div>
									</div>

									<dxi-column sortOrder="desc" width="auto" format="dd-MM-yyyy HH:mm:ss" dataType="date" dataField="creationDate">
									</dxi-column>

									<!-- Dynamic columns (render helpArticles specially) -->
									<ng-container *ngFor="let columnName of SelectedProperties">
										<ng-container *ngIf="columnName === 'helpArticles'; else normalColumnSingle">
											<dxi-column [dataField]="columnName" caption="Help articles" cellTemplate="helpArticlesTemplate" [width]="'auto'" [minWidth]="160" [allowResizing]="false">
											</dxi-column>
										</ng-container>

										<ng-template #normalColumnSingle>
											<ng-container *ngIf="isWideColumn(columnName); else normalNarrowSingle">
												<dxi-column [dataField]="columnName"></dxi-column>
											</ng-container>
											<ng-template #normalNarrowSingle>
												<dxi-column [dataField]="columnName" width="auto" [caption]="columnName"></dxi-column>
											</ng-template>
										</ng-template>
									</ng-container>

									<!-- Action buttons -->
									<dxi-column type="buttons" width="40px">
										<dxi-button hint="Expand message" icon="search" [onClick]="expandMessageButton"></dxi-button>
									</dxi-column>

									<!-- ✅ helpArticlesTemplate MUST be inside the grid -->
									<div *dxTemplate="let cell of 'helpArticlesTemplate'">
										<!-- Only show anything for Error rows -->
										<ng-container *ngIf="cell.data?.jobLogType == '4'; else empty">
											<ng-container *ngIf="hasAnyArticleIds(cell.value); else requestHelp">
												<div class="mp-cell">
													<div *ngFor="let ha of cell.value" class="mp-row">
														<button *ngIf="ha.articleIds?.length" type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="openIssueHelp(ha, cell.data?.message ?? cell.data?.description ?? null)">
															View help articles
														</button>
													</div>
												</div>
											</ng-container>

											<ng-template #requestHelp>
												<button type="button" class="btn btn-outline-primary btn-sm mp-action-btn w-100" (click)="requestHelpForRow(cell.data)">
													Request help for this error
												</button>
											</ng-template>
										</ng-container>

										<ng-template #empty>
											<!-- render nothing for non-errors -->
											<span style="display:none;"></span>
										</ng-template>
									</div>

								</dx-data-grid>

								<ng-container *ngIf="SelectedLogType == JobLogType.AmountMismatch">
									<div style="font-size:12px">*: This difference is more than just a VAT difference, please check the invoice.
									</div>
									<div style="font-size:12px">**: The difference here is a VAT difference.</div>
								</ng-container>
							</fieldset>
						</ng-container>

					</div>
				</dx-scroll-view>
			</fieldset>
		</div>

		<br />

		<div *ngIf="!entriesAvailable && hasLogBeenClicked">
			Link has been executed, but there was nothing to transfer
		</div>
	</div>
</div>

<div *ngIf="contextMenuVisible && (canUseJobLogPatternMatcherSubject | async)" class="log-id-context-menu" [style.left.px]="contextMenuX" [style.top.px]="contextMenuY" (click)="$event.stopPropagation()" (contextmenu)="preventContextMenuClose($event)">
	<div class="context-menu-header">
		<div>
			<div class="context-menu-kicker">Admin IDs</div>
			<strong>Log run identifiers</strong>
		</div>
		<button type="button" class="context-close" (click)="closeLogContextMenu()">x</button>
	</div>

	<div *ngIf="contextMenuLogHistory" class="context-menu-section always-open">
		<div class="context-menu-section-title">Log session ID</div>
		<div class="context-id-row">
			<span>{{ contextMenuLogHistory.instanceId }}</span>
			<button type="button" (click)="copyInstanceId(contextMenuLogHistory.instanceId, $event)">Copy</button>
		</div>
	</div>

	<div *ngIf="contextMenuLoading" class="context-loading">Loading batch IDs...</div>
	<div *ngIf="contextMenuError" class="context-error">{{ contextMenuError }}</div>

	<ng-container *ngIf="contextMenuInspector as inspector">
		<button type="button" class="context-menu-action" (click)="copyDurableInstanceIds(inspector, $event)">Copy all Durable IDs</button>

		<div class="context-menu-summary">
			<span>{{ inspector.totalBatches }} batches</span>
			<span>{{ inspector.totalItems }} entities</span>
			<span>{{ inspector.failedItems }} failed</span>
		</div>

		<div class="context-all-entities">
			<div class="context-entity-header">
				<span>All entities mapped to batches</span>
				<button type="button" (click)="copyAllEntityBatchRows(inspector, $event)">Copy map</button>
			</div>

			<div class="context-entity-list compact">
				<div *ngFor="let row of getContextEntityBatchRows(inspector)" class="context-entity-row mapped">
					<strong>Batch {{ row.batchIndex }}</strong>
					<span>{{ row.objectId }}</span>
					<small>{{ row.statusText }}</small>
				</div>
			</div>
		</div>

		<div class="context-batch-list">
			<div *ngFor="let batch of inspector.batches" class="context-batch" [ngClass]="getBatchStatusClass(batch.statusText)">
				<button type="button" class="context-batch-toggle" (click)="toggleContextBatch(batch, $event)">
					<span class="context-caret">{{ isContextBatchExpanded(batch) ? 'v' : '>' }}</span>
					<strong>Batch {{ batch.batchIndex }}</strong>
					<span class="status-pill" [ngClass]="getBatchStatusClass(batch.statusText)">{{ batch.statusText }}</span>
					<small>{{ batch.totalItems }} entities</small>
				</button>

				<div *ngIf="isContextBatchExpanded(batch)" class="context-batch-details">
					<div class="context-id-label">Durable Scheduler instance ID</div>
					<div class="context-id-row">
						<span>{{ batch.durableInstanceId || 'No Durable instance ID' }}</span>
						<button type="button" (click)="copyInstanceId(batch.durableInstanceId, $event)">Copy</button>
					</div>

					<div class="context-id-grid">
						<div><span>Queue batch ID</span><strong>{{ batch.queueBatchId }}</strong></div>
						<div><span>Queue ID</span><strong>{{ batch.queueId }}</strong></div>
						<div><span>Traceparent</span><strong>{{ batch.traceParent || 'None' }}</strong></div>
					</div>

					<div class="context-entity-header">
						<span>Entity / object IDs</span>
						<button type="button" (click)="copyBatchEntityIds(batch, $event)">Copy all</button>
					</div>

					<div class="context-entity-list">
						<div *ngFor="let item of batch.items" class="context-entity-row">
							<span>{{ item.objectId }}</span>
							<small>{{ item.statusText }}</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<al-freshdesk-help-modal #helpModal></al-freshdesk-help-modal>
<app-missing-article-feedback #missingArticleFeedback></app-missing-article-feedback>
